import { getStore } from '~/mobx/AppStore';

function randomIntFromInterval(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function getRandomDelay(uuid: string) {
    const firstNumber = parseInt(uuid.replace(/-/g, '').replace(/[^\d]/g, '')[0], 10);
    return randomIntFromInterval(200 + firstNumber, 500);
}

function changeSelectedRegion(regionId: string) {
    const { regionPreviewStore } = getStore();
    regionPreviewStore.setIsChangingRegion(true);
    setTimeout(() => {
        regionPreviewStore.setIsChangingRegion(false);
    }, getRandomDelay(regionId));
}
export default changeSelectedRegion;
